var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.5696 1.71429C11.5696 1.52567 11.4535 1.35882 11.2867 1.28627C11.1126 1.21373 10.9095 1.25 10.7789\n         1.38783L9.8358 2.32366C8.81292 1.35882 7.42732 0.785714 5.99819 0.785714C2.92955 0.785714 0.426758 3.2885 0.426758\n         6.35714C0.426758 9.42578 2.92955 11.9286 5.99819 11.9286C7.65946 11.9286 9.22642 11.1959 10.2856 9.91908C10.3581 9.82478\n         10.3581 9.68694 10.2711 9.60714L9.2772 8.60603C9.22642 8.5625 9.16113 8.54074 9.09584 8.54074C9.03055 8.54799 8.96526 8.57701\n         8.92899 8.62779C8.21805 9.54911 7.15165 10.0714 5.99819 10.0714C3.95243 10.0714 2.2839 8.4029 2.2839 6.35714C2.2839 4.31138\n         3.95243 2.64286 5.99819 2.64286C6.94852 2.64286 7.84808 3.00558 8.53 3.63672L7.52888 4.63783C7.39104 4.76841 7.35477 4.97154\n         7.42732 5.13839C7.49986 5.3125 7.66671 5.42857 7.85533 5.42857H11.1053C11.3592 5.42857 11.5696 5.21819 11.5696 4.96429V1.71429Z",
          fill: "#333333",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }